export const createTimeIntervals = (): string[] => {
  const result: string[] = [];

  const hoursInDay = 24;
  const minutesInHour = 60;
  const stepInMinutes = 15;
  const zeroBorder = 10;

  for (let i = 0; i < hoursInDay; i++) {
    for (let j = 0; j < minutesInHour; j++) {
      if (j % stepInMinutes === 0) {
        const handledI = i < zeroBorder ? `0${i}` : i;
        const handledJ = j < zeroBorder ? `0${j}` : j;
        result.push(`${handledI}:${handledJ}`);
      }
    }
  }

  result.push('00:00');

  return result;
};
